import { render } from "./Index_team_en_m.vue?vue&type=template&id=efb029c8&scoped=true"
import script from "./Index_team_en_m.vue?vue&type=script&lang=js"
export * from "./Index_team_en_m.vue?vue&type=script&lang=js"

import "./Index_team_en_m.vue?vue&type=style&index=0&id=efb029c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-efb029c8"

export default script